import Auth from "@aws-amplify/auth";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import React from "react";
import { useHistory } from "react-router";
import NewPasswordForm, {
  NewPasswordFormValues,
} from "../components/Auth/NewPasswordForm";
import SiginInForm, { LoginFormValues } from "../components/Auth/SiginInForm";
import { ROUTES } from "../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage:
      "url(https://cdn.shopify.com/s/files/1/0276/3082/9633/files/protect-firstmitsatz_1560x1200_1_1296x.png)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignIn: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [user, setUser] = React.useState<any>();

  const _handleLogin = ({ password, username }: LoginFormValues) => {
    return new Promise((resolve, reject) => {
      Auth.signIn(username, password)
        .then((user) => {
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            setUser(user);
            resolve(user);
          } else {
            resolve(user);
            history.replace(ROUTES.HOME);
          }
        })
        .catch((error) => reject({ error }));
    });
  };

  const _handleNewPassword = ({ password }: NewPasswordFormValues) => {
    return new Promise((resolve, reject) => {
      Auth.completeNewPassword(user, password)
        .then((user) => {
          resolve(user);
          history.replace(ROUTES.HOME);
        })
        .catch((error) => reject({ error }));
    });
  };

  return (
    <Grid container component="main" className={classes.root} spacing={8}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {!!user ? "Passwort ändern" : "Anmelden"}
          </Typography>
          {!!user ? (
            <NewPasswordForm onSubmit={_handleNewPassword} />
          ) : (
            <SiginInForm onSubmit={_handleLogin} />
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default SignIn;
